import EventEmitter from 'eventemitter3';

export default class WSEQBManager {
  constructor(props) {
    this.props = Object.assign({
      entries: []
    }, props);

    this.emitter = new EventEmitter();
    this.addEntries(this.props.entries);
    this.onTracking = this.onTracking.bind(this);
  }

  addEntries(entries) {
    const existingIds = this.props.entries.map((entry) => entry.id);
    const newEntries = entries.filter((entry) => !existingIds.includes(entry.id));
    this.props.entries.push(...newEntries);
    this.validEntryIds = this.props.entries.map((entry) => entry.id);
  }

  validate(payload) {
    const isValidEntry = this.validEntryIds.includes(payload.id);
    return isValidEntry;
  }

  on(name, fn, ctx) {
    this.emitter.on(name, fn, ctx);
  }

  onTracking(payload) {
    if (!payload) return;
    const isValid = this.validate(payload);
    if (isValid) {
      this.emitter.emit(payload.type, payload);
      this.emitter.emit('*', payload);
    }
  }
};


// WEBPACK FOOTER //
// ./src/manager.js